import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
import {RolesList} from '@gtpl/shared-models/gtpl';
import * as bcrypt from 'bcrypt'; 
import { EmployeeDetails } from "../employee-details/employee-details.entity";
@Entity('user')
export class UserEntity {  
    @PrimaryGeneratedColumn('increment',{name:'id'}) id: number;  
    @Column({ 
        type: 'varchar', 
        nullable: false, 
        unique: true,
        name:'username' 
    }) 
    username: string;
    @Column({ 
        type: 'varchar', 
        nullable: false 
    }) 
    password?: string;  @Column({ 
        type: 'varchar', 
        nullable: false 
    }) 
    @Column({ 
        type: 'varchar', 
        nullable: false 
    })
    email: string;
    @Column({
        type:'enum',
        // length:5,
        nullable: true,
        enum:RolesList,
        default:RolesList.LONE,
        name:"role"
        })
    role:RolesList;
    @Column("int",{
        nullable: true,
        name:"employee_id"
        })
    employeeId:number;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"status"
        })
      status:boolean;
    @BeforeInsert()  
    // @BeforeUpdate()
        async hashPassword() {
            if(this.password){
                console.log('password'+this.password)
                this.password = await bcrypt.hash(this.password, 10);  
            }
    }
    // @BeforeUpdate()  
    //     async hashPassword() {
    //     this.password = await bcrypt.hash(this.password, 10);  
    // }
    @ManyToOne(type => UserEntity)owner?: UserEntity;
    @OneToOne(() => EmployeeDetails, employeeDetails => employeeDetails.Id) 
    // specify inverse side as a second parameter
    employeeDetails: EmployeeDetails;
}